import { Logo } from "@/components/navigation/Logo";
import { Link } from "react-router-dom";

export function Footer() {
    return (
        <footer className="border-t py-8 mt-12">
            <div className="mx-auto max-w-6xl px-4 flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
                <div className="flex flex-col gap-3">
                    <Logo />
                    <p className="text-xs text-muted-foreground max-w-sm">Turning motion into meaning. © {new Date().getFullYear()} Arrowise.</p>
                </div>
                <div className="flex items-center gap-6 text-sm">
                    <Link to="/terms" className="hover:text-primary cursor-pointer">Terms</Link>
                    <Link to="/privacy" className="hover:text-primary cursor-pointer">Privacy</Link>
                    <Link to="/contact" className="hover:text-primary cursor-pointer">Contact</Link>
                </div>
            </div>
        </footer>
    );
}
